/**
 * Конвертирует value из null в undefined
 *
 * @param value Значение для конвертации
 * @returns
 */
export function unnull<T>(value: T | null | undefined): T | undefined {
  return value === null ? undefined : value;
}
